export default __webpack_public_path__ + "static/media/4.23795dd8.jpg";